import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import ChatConversation from './pages/ChatConversation';
import AddFriendsPage from './pages/AddFriendsPage'; // Your existing add friends page
import PostStoryPage from './pages/PostStoryPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/chat/:friendId" element={<ChatConversation />} />
        <Route path="/add-friends" element={<AddFriendsPage />} />
        <Route path="/post-story" element={<PostStoryPage />} />
      </Routes>
    </Router>
  );
}

export default App;
